import { gql } from '@apollo/client'

export const CREATE_USER_CALENDAR_MUTATION = gql`
  mutation createUserCalendar {
    createUserCalendar {
      calendarUrl
    }
  }
`

export interface CreateUserCalendarData {
  createUserCalendar: {
    calendarUrl: string
  }
}
